"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notEmptyAndHasDescriptionSpecialChars = exports.hasDescriptionSpecialChars = exports.notEmptyAndHasSpecialChars = exports.hasSpecialChars = exports.capitalizeFirstLetter = exports.concatStrings = exports.validateEmail = exports.isEmptyString = exports.testRegExp = void 0;
var testRegExp = function (regExp, str) { return new RegExp(regExp).test(str); };
exports.testRegExp = testRegExp;
var isEmptyString = function (str) {
    if (str === void 0) { str = ''; }
    return str.trim() === '';
};
exports.isEmptyString = isEmptyString;
var validateEmail = function (email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email.toLowerCase());
};
exports.validateEmail = validateEmail;
var concatStrings = function (arr, concatChar) {
    if (concatChar === void 0) { concatChar = '.'; }
    var concatenateStr = '';
    arr.forEach(function (str) {
        if (str) {
            var newStr = String(str);
            if (concatenateStr) {
                concatenateStr = concatenateStr.concat(concatChar, newStr);
            }
            else {
                concatenateStr = newStr;
            }
        }
    });
    return concatenateStr;
};
exports.concatStrings = concatStrings;
var capitalizeFirstLetter = function (text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
};
exports.capitalizeFirstLetter = capitalizeFirstLetter;
var hasSpecialChars = function (str) {
    if (str === void 0) { str = ''; }
    return !(0, exports.testRegExp)(/^([a-zA-Z0-9 _-]+)$/, str);
};
exports.hasSpecialChars = hasSpecialChars;
var notEmptyAndHasSpecialChars = function (value) { return !(0, exports.isEmptyString)(value) && (0, exports.hasSpecialChars)(value); };
exports.notEmptyAndHasSpecialChars = notEmptyAndHasSpecialChars;
var hasDescriptionSpecialChars = function (str) {
    if (str === void 0) { str = ''; }
    return !(0, exports.testRegExp)(/^([a-zA-Z0-9 _.,!;-]+)$/, str);
};
exports.hasDescriptionSpecialChars = hasDescriptionSpecialChars;
var notEmptyAndHasDescriptionSpecialChars = function (value) { return !(0, exports.isEmptyString)(value) && (0, exports.hasDescriptionSpecialChars)(value); };
exports.notEmptyAndHasDescriptionSpecialChars = notEmptyAndHasDescriptionSpecialChars;
